import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input } from '@angular/core';
import { SettingsSetterDirective } from 'src/business/models/general-element-settings';
import { Breadcrumb } from 'src/core-lib/navigation/models/breadcrumb.interface';
import { StorageUtil } from 'src/utils/storage.util';



@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsComponent {
    @Input() public breadcrumbs: Breadcrumb[] = StorageUtil.get<{breadcrumb:Breadcrumb[]}>('page').breadcrumb;
    @HostBinding('attr.aria-label') @Input() ariaLabel: string;
    @HostBinding('attr.role') role = 'navigation';
    @HostBinding('attr.id') _id = 'breadcrumbs';

    constructor(public elm:ElementRef<HTMLElement>){}


}
@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BreadcrumbsGridComponent extends SettingsSetterDirective {
    @Input() public breadcrumbs: Breadcrumb[] = StorageUtil.get<{breadcrumb:Breadcrumb[]}>('page').breadcrumb;
    @HostBinding('attr.aria-label') @Input() ariaLabel: string;
    @HostBinding('attr.role') role = 'navigation';
    @HostBinding('attr.id') _id = 'breadcrumbs';

}
